import { TxStatus, WalletType } from "@cede/types";

export const fakePortfolio = {
  tokens: [
    {
      token: "BTC",
      totalBalance: 0.005510221106058,
      freeBalance: 0.005510221106058,
      balancesByAccount: [
        {
          accountName: "Coinbase 1",
          totalBalance: 4.1106058e-8,
          freeBalance: 4.1106058e-8,
          exchangeId: "coinbase",
          refTotalBalance: 0,
          refFreeBalance: 0,
          walletTypes: {
            [WalletType.SPOT]: {
              totalBalance: 123,
              freeBalance: 123,
              refTotalBalance: 1234,
              refFreeBalance: 1234,
            },
          },
        },
        {
          accountName: "Binance 1",
          totalBalance: 0.00551018,
          freeBalance: 0.00551018,
          exchangeId: "binance",
          refTotalBalance: 0,
          refFreeBalance: 0,
          walletTypes: {
            [WalletType.SPOT]: {
              totalBalance: 123,
              freeBalance: 123,
              refTotalBalance: 1234,
              refFreeBalance: 1234,
            },
          },
        },
      ],
      refTotalBalance: 0,
      refFreeBalance: 0,
    },
  ],
  total: 2000,
  transactions: [
    {
      from: {
        account: {
          exchangeId: "binance",
          accountName: "Binance 1",
          cexId: "binance",
        },
        transaction: {
          amount: 441.0324,
          refAmount: 0,
          tokenSymbol: "NEAR",
          transactionId: "4d06af5bfe6a488183ed186b9549cbe5",
          fee: {
            tokenSymbol: "NEAR",
            amount: 0.01,
          },
          status: TxStatus.OK,
          timestamp: 1668269961000,
        },
        wallet: {
          depositAddress: "someDepositAddress",
          walletType: WalletType.SPOT,
        },
      },
      to: {
        account: {
          address: "nikt.near",
          network: "near",
        },
        transaction: {
          transactionHash: "hash",
          fee: {
            tokenSymbol: "NEAR",
            amount: 0.01,
          },
          tokens: [
            {
              amount: 441.0324,
              refAmount: 0,
              tokenSymbol: "NEAR",
              address: "nikt.near",
            },
          ],
          status: TxStatus.OK,
          timestamp: 1668269961000,
        },
      },
      type: "withdrawal",
    },
  ],
  historicalBalances: [],
};

export const fakeTokenNamesAndSymbols = [
  {
    name: "Bitcoin",
    symbol: "BTC",
  },
  {
    name: "Ethereum",
    symbol: "ETH",
  },
];
